// ============================================================================
// GsToggle — interrupteur compact (@gs/ui)
// ============================================================================
// MASTER-UG-CONFIG-FINITION-VISUELLE 2026-06-22 : ~36×20px, pastille 16px.
// ON brand-500 (marque) / OFF slate-200 — zéro green-*.
import type { ButtonHTMLAttributes } from 'react';

export interface GsToggleProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onChange' | 'type'> {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export function GsToggle({
  checked,
  onCheckedChange,
  disabled,
  className,
  'aria-label': ariaLabel,
  ...rest
}: GsToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={`relative inline-flex h-5 w-9 shrink-0 touch-manipulation items-center rounded-full transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500 disabled:opacity-45 motion-reduce:transition-none ${
        checked
          ? 'bg-brand-500 dark:bg-brand-500'
          : 'bg-slate-200 dark:bg-slate-600'
      } ${className ?? ''}`}
      {...rest}
    >
      <span
        aria-hidden
        className={`inline-block h-4 w-4 rounded-full bg-white shadow-sm transition-transform motion-reduce:transition-none ${
          checked ? 'translate-x-[18px]' : 'translate-x-0.5'
        }`}
      />
    </button>
  );
}
